type Props = {
    title: string;
    onSuccess: () => void;
    onCancel: () => void;
};

export default function LeaveChannelModal({ title, onSuccess, onCancel }: Props) {
    return (
        <div id="confirmLeave" className="leave-modal">
            <div className="leave-modal-bg" onClick={onCancel} />
            <div className="leave-modal-card" role="dialog" aria-modal="true" aria-labelledby="leave-modal-title">
                <div className="leave-modal-icon" aria-hidden="true">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <path d="M10 15l5-3-5-3v6z" fill="currentColor" opacity="0"/>
                        <path d="M15.59 7L14.17 8.41 17.76 12l-3.59 3.59L15.59 17 20.59 12 15.59 7zM4 5h8v2H6v10h6v2H4V5z" fill="currentColor"/>
                    </svg>
                </div>
                <p id="leave-modal-title" className="leave-modal-title">{title}</p>
                <p className="leave-modal-sub">You’ll disconnect from this session and stop sharing your camera and mic.</p>
                <div className="leave-modal-actions">
                    <button className="leave-btn-cancel" onClick={onCancel}>Stay</button>
                    <button className="leave-btn-confirm" onClick={onSuccess}>Leave</button>
                </div>
            </div>

            <style>{`
                .leave-modal {
                    display: none;
                    position: fixed;
                    inset: 0;
                    align-items: center;
                    justify-content: center;
                    z-index: 10050;
                    padding: 1rem;
                }

                .leave-modal.is-active {
                    display: flex;
                }

                .leave-modal-bg {
                    position: absolute;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.45);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                }

                .leave-modal-card {
                    position: relative;
                    width: 100%;
                    max-width: 360px;
                    background: var(--hx-card);
                    border: 1px solid var(--hx-line);
                    border-radius: var(--hx-radius);
                    padding: 1.75rem 1.5rem 1.5rem;
                    box-shadow: var(--hx-shadow);
                    text-align: center;
                    animation: leaveIn 0.2s ease;
                }

                @keyframes leaveIn {
                    from { opacity: 0; transform: translateY(10px) scale(0.98); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }

                .leave-modal-icon {
                    width: 52px;
                    height: 52px;
                    margin: 0 auto 1rem;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #fef2f2;
                    color: var(--hx-danger);
                    border: 1px solid #fecaca;
                }

                .leave-modal-title {
                    font-size: 1.15rem;
                    font-weight: 650;
                    color: var(--hx-ink);
                    margin: 0 0 0.5rem;
                    letter-spacing: -0.01em;
                }

                .leave-modal-sub {
                    font-size: 0.875rem;
                    line-height: 1.5;
                    color: var(--hx-muted);
                    margin: 0 0 1.5rem;
                }

                .leave-modal-actions {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 0.65rem;
                }

                .leave-btn-cancel,
                .leave-btn-confirm {
                    padding: 0.75rem 1rem;
                    border-radius: 11px;
                    font-weight: 600;
                    font-size: 0.9rem;
                    border: none;
                    cursor: pointer;
                    transition: background 0.15s, transform 0.1s;
                    font-family: inherit;
                }

                .leave-btn-cancel {
                    background: var(--hx-line-2);
                    color: var(--hx-ink-2);
                    border: 1px solid var(--hx-line);
                }

                .leave-btn-cancel:hover {
                    background: var(--hx-line);
                }

                .leave-btn-confirm {
                    background: var(--hx-danger);
                    color: #fff;
                }

                .leave-btn-confirm:hover {
                    background: var(--hx-danger-hover);
                }

                .leave-btn-cancel:active,
                .leave-btn-confirm:active {
                    transform: scale(0.98);
                }
            `}</style>
        </div>
    );
}
